import { useState, useEffect } from 'react'

interface UseBrowsePageStateOptions {
  urlFilters: Record<string, unknown>
  setUrlFilters: (updates: Record<string, unknown>) => void
}

export function useBrowsePageState({ urlFilters, setUrlFilters }: UseBrowsePageStateOptions) {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
  const [searchInput, setSearchInput] = useState((urlFilters.q as string) || '')

  // Sync search input when URL changes (e.g., back button)
  useEffect(() => {
    setSearchInput((urlFilters.q as string) || '')
  }, [urlFilters.q])

  // Debounced search - update URL after 300ms
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== ((urlFilters.q as string) || '')) {
        setUrlFilters({ q: searchInput || null })
      }
    }, 300)
    return () => clearTimeout(timer)
  }, [searchInput, urlFilters.q, setUrlFilters])

  const handleSort = (field: string) => {
    const newOrder = urlFilters.sort === field && urlFilters.order === 'asc' ? 'desc' : 'asc'
    setUrlFilters({ sort: field, order: newOrder })
  }

  const toggleOrder = () => {
    const currentOrder = urlFilters.order || 'asc'
    setUrlFilters({ order: currentOrder === 'asc' ? 'desc' : 'asc' })
  }

  return {
    mobileFiltersOpen,
    setMobileFiltersOpen,
    searchInput,
    setSearchInput,
    handleSort,
    toggleOrder,
  }
}
